export default {
    title: 'Your notifications',
    empty: `You don't have any notifications.`
}
